import { memo } from "react";

const LeftAlignment = () => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2718_19849)">
      <path d="M15 0H0V15H15V0Z" fill="white" fillOpacity="0.01" />
      <path
        d="M1.875 4.375H13.125"
        stroke="#7A7A7A"
        strokeWidth="1.03448"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M1.875 7.5H9.375" stroke="#7A7A7A" strokeWidth="1.03448" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M1.875 10.625H4.375"
        stroke="#7A7A7A"
        strokeWidth="1.03448"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2718_19849">
        <rect width="15" height="15" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default memo(LeftAlignment);
